export default function County() {
    return [
      { label: "Alameda", value: "Alameda" },
      { label: "Alpine", value: "Alpine" },
      { label: "Amador", value: "Amador" },
      { label: "Butte", value: "Butte" },
      { label: "Calaveras", value: "Calaveras" },
      { label: "Colusa", value: "Colusa" },
      { label: "Contra Costa", value: "Contra Costa" },
      { label: "Del Norte", value: "Del Norte" },
      { label: "El Dorado", value: "El Dorado" },
      { label: "Fresno", value: "Fresno" },
      { label: "Glenn", value: "Glenn" },
      { label: "Humboldt", value: "Humboldt" },
      { label: "Imperial", value: "Imperial" },
      { label: "Inyo", value: "Inyo" },
      { label: "Kern", value: "Kern" },
      { label: "Kings", value: "Kings" },
      { label: "Lake", value: "Lake" },
      { label: "Lassen", value: "Lassen" },
      { label: "Los Angeles", value: "Los Angeles" },
      { label: "Madera", value: "Madera" },
      { label: "Marin", value: "Marin" },
      { label: "Mariposa", value: "Mariposa" },
      { label: "Mendocino", value: "Mendocino" },
      { label: "Merced", value: "Merced" },
      { label: "Modoc", value: "Modoc" },
      { label: "Mono", value: "Mono" },
      { label: "Monterey", value: "Monterey" },
      { label: "Napa", value: "Napa" },
      { label: "Nevada", value: "Nevada" },
      { label: "Orange", value: "Orange" },
      { label: "Placer", value: "Placer" },
      { label: "Plumas", value: "Plumas" },
      { label: "Riverside", value: "Riverside" },
      { label: "Sacramento", value: "Sacramento" },
      { label: "San Benito", value: "San Benito" },
      { label: "San Bernardino", value: "San Bernardino" },
      { label: "San Diego", value: "San Diego" },
      { label: "San Francisco", value: "San Francisco" },
      { label: "San Joaquin", value: "San Joaquin" },
      { label: "San Luis Obispo", value: "San Luis Obispo" },
      { label: "San Mateo", value: "San Mateo" },
      { label: "Santa Barbara", value: "Santa Barbara" },
      { label: "Santa Clara", value: "Santa Clara" },
      { label: "Santa Cruz", value: "Santa Cruz" },
      { label: "Shasta", value: "Shasta" },
      { label: "Sierra", value: "Sierra" },
      { label: "Siskiyou", value: "Siskiyou" },
      { label: "Solano", value: "Solano" },
      { label: "Sonoma", value: "Sonoma" },
      { label: "Stanislaus", value: "Stanislaus" },
      { label: "Sutter", value: "Sutter" },
      { label: "Tehama", value: "Tehama" },
      { label: "Trinity", value: "Trinity" },
      { label: "Tulare", value: "Tulare" },
      { label: "Tuolumne", value: "Tuolumne" },
      { label: "Ventura", value: "Ventura" },
      { label: "Yolo", value: "Yolo" },
      { label: "Yuba", value: "Yuba" },
    ];
}